import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useCookies } from "react-cookie";

import Login from './pages/login'
import Dashboard from './pages/dashboard'
import Registration from "./pages/register";
import History from "./pages/history";
import Wallet from "./pages/wallet";
import Settings from "./pages/settings";
import ContactPage from "./pages/contact";
import ForgotPassword from "./pages/forgotpassword";
import Admin_dashboard from "./pages/admin_dashboard";
import LandingPage from "./pages/landing_page";
import MarketPlace from "./pages/marketPlace";
import CentralMarket from "./pages/centralMarket";
import Corridor from "./pages/corridor";
import PrivacyPolicy from "./pages/privacy_policy";
import TermsOfService from "./pages/terms_of_service";
import VerifyEmail from "./pages/verify_email";
import BlogPage from "./pages/blog";

import BuyerLandingPage from "./pages/buyer_landing";
import SellerLandingPage from "./pages/seller_landing";
import InvestorLandingPage from "./pages/investor_landing";
import SearchLandingPage from "./pages/search_landing";

const SessionManager = () => {
  const [cookies, , removeCookie] = useCookies(["username"]);

  // Browser-close logout: on first load, if no sessionStorage flag exists, clear the cookie
  useEffect(() => {
    if (cookies.username) {
      const isSessionAlive = sessionStorage.getItem("sessionActive");
      if (!isSessionAlive) {
        // Session was not alive — browser was closed, log out
        removeCookie("username", { path: '/' });
        removeCookie("name", { path: '/' });
        window.location.href = "/login?expired=true";
        return;
      }
    }
    // Mark session as active
    sessionStorage.setItem("sessionActive", "1");
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    let timeoutId;
    const INACTIVITY_LIMIT = 5 * 60 * 1000; // 5 minutes

    const logout = () => {
      if (cookies.username) {
        removeCookie("username", { path: '/' });
        removeCookie("name", { path: '/' });
        window.location.href = "/login?expired=true";
      }
    };

    const resetTimer = () => {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(logout, INACTIVITY_LIMIT);
    };

    if (cookies.username) {
      // Activity events to monitor
      const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];

      events.forEach(event => window.addEventListener(event, resetTimer));
      resetTimer(); // Start timer initially

      return () => {
        if (timeoutId) clearTimeout(timeoutId);
        events.forEach(event => window.removeEventListener(event, resetTimer));
      };
    }
  }, [cookies.username, removeCookie]);

  return null;
};

export default function App() {
  return (
    <Router>
      <SessionManager />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/register" element={<Registration />} />
        <Route path="/history" element={<History />} />
        <Route path="/wallet" element={<Wallet />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route path="/admin_dashboard" element={<Admin_dashboard />} />
        <Route path="/market_dashboard" element={<MarketPlace />} />
        <Route path="/central_market" element={<CentralMarket />} />
        <Route path="/corridor" element={<Corridor />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/verify_email" element={<VerifyEmail />} />
        <Route path="/blog" element={<BlogPage />} />

        {/* Dedicated Audience Landing Pages */}
        <Route path="/buy-bulk-crops" element={<BuyerLandingPage />} />
        <Route path="/sell-crops" element={<SellerLandingPage />} />
        <Route path="/farm-investments" element={<InvestorLandingPage />} />

        {/* Dedicated High-Intent Search Intent Pages */}
        <Route path="/buy-bulk-cocoa-nigeria" element={<SearchLandingPage pageKey="buy-bulk-cocoa-nigeria" />} />
        <Route path="/buy-cashew-nigeria" element={<SearchLandingPage pageKey="buy-cashew-nigeria" />} />
        <Route path="/buy-sesame-seeds-nigeria" element={<SearchLandingPage pageKey="buy-sesame-seeds-nigeria" />} />
        <Route path="/verified-agricultural-suppliers-nigeria" element={<SearchLandingPage pageKey="verified-agricultural-suppliers-nigeria" />} />
        <Route path="/sell-crops-to-bulk-buyers" element={<SearchLandingPage pageKey="sell-crops-to-bulk-buyers" />} />
        <Route path="/farm-investment-opportunities-nigeria" element={<SearchLandingPage pageKey="farm-investment-opportunities-nigeria" />} />
        <Route path="/agricultural-commodity-prices-nigeria" element={<SearchLandingPage pageKey="agricultural-commodity-prices-nigeria" />} />
        <Route path="/export-agricultural-produce-from-nigeria" element={<SearchLandingPage pageKey="export-agricultural-produce-from-nigeria" />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}